import React, { useEffect, useState } from "react";
import { Form, Spinner, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import Swal from "sweetalert2";
import { studyEventFormSchemaServices } from "../../../../../APIServices/studyEventFormSchemaServices";
import { studyEventManagementServices } from "../../../../../APIServices/studyEventManagementServices";
import Loader from "../../../../../img/Document scan.gif"
const EventListForInitiateForm = ({ tableRef, onMouseDown, metadata }) => {
  const [eventColumns, setEventColumns] = useState([]);
  const [eventRows, setEventRows] = useState([]);
  const [eventInitiatedForm, setEventInitiatedForm] = useState([]);
  const [version, setVersion] = useState("");
  const [schemaId, setSchemaId] = useState("");
  const [eventSchema, setEventSchema] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  let { studyId } = useParams();
  const [assignButtonLoader, setAssignButtonLoader] = useState(false)
  const [unassignButtonLoader, setUnassignButtonLoader] = useState(false)

  const getStudyEventColumnData = async (e) => {
    let data = await studyEventManagementServices.getStudyEventColumnData(
      "active",
      studyId
    );
    const requiredColumns = [
      "EVENTID",
      "EVENTDAY",
      "TIMEPOINTID",
      "TIMEPOINTLABEL",
    ];
    const filteredColumn = (data?.data || []).filter((item) =>
      requiredColumns.includes(item.columnName)
    );
    setEventColumns(filteredColumn);
  };

  const getEventBasedonSchema = async (e) => {
    setLoading(true);
    let data = await studyEventFormSchemaServices.getEventBasedonSchema(
      studyId,
      schemaId
    );
    setEventRows(data?.data || []);
    setLoading(false);
  };

  const getEventFormSchema = async (e) => {
    let data = await studyEventFormSchemaServices.getEventFormSchema(
      "active",
      studyId
    );
    setEventSchema(data?.data || []);
    setSchemaId(data?.data[0]?.schemaId || []);
  };

  const findInitiatedEventForm = async (e) => {
    setDataLoading(true);
    let data = await studyEventManagementServices.findInitiatedEventForm(
      studyId,
      metadata?.formId,
      schemaId,
      version
    );
    setEventInitiatedForm(data?.data || []);
    setDataLoading(false);
  };

  useEffect(() => {
    if (studyId && schemaId && version) {
      findInitiatedEventForm();
    }
  }, [studyId, schemaId, version]);

  const assignStudyEventSchemaInitiate = async (eventId, timePointUniqueId) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Assign Form Study Event initiate!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, assign it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setAssignButtonLoader(true)
        let userData = {};
        userData.studyId = studyId;
        userData.schemaId = schemaId;
        userData.eventId = eventId;
        userData.timePointUniqueId = timePointUniqueId || "";
        userData.version = version;
        userData.formId = metadata?.formId;
        userData.formName = metadata?.formName;
        let data =
        await studyEventManagementServices.assignStudyEventSchemaInitiate(
          userData
        );
        if (data?.statusCode === 200) {
          findInitiatedEventForm();
        }
      }
      setAssignButtonLoader(false)
    });
  };

  const unassignStudyEventSchemaInitiate = async (
    eventId,
    timePointUniqueId
  ) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to unassign Form Study Event initiate!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, unassign it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setUnassignButtonLoader(true)
        let userData = {};
        userData.studyId = studyId;
        userData.schemaId = schemaId;
        userData.eventId = eventId;
        userData.timePointUniqueId = timePointUniqueId || "";
        userData.version = version;
        userData.formId = metadata?.formId;
        userData.formName = metadata?.formName;
        let data =
        await studyEventManagementServices.unassignStudyEventSchemaInitiate(
          userData
        );
        if (data?.statusCode === 200) {
          findInitiatedEventForm();
        }
      }
      setUnassignButtonLoader(false)
    });
  };

  useEffect(() => {
    setSchemaId("");
    setVersion("");
  }, [metadata]);

  useEffect(() => {
    getStudyEventColumnData();
    getEventFormSchema();
  }, []);

  useEffect(() => {
    if (schemaId) {
      getEventBasedonSchema();
    }
  }, [schemaId]);
  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"15%"}
        style={{ height: "-webkit-fill-available" }}
      >
        <Table ref={tableRef} className="m-0 custom-table" hover striped>
          <thead className="position-sticky top-0 z-1">
            <tr>
              <th>Form Version</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: metadata?.version || 1 }, (_, i) => i + 1)
              ?.reverse()
              ?.map((versionNumber, index) => (
                <tr
                  onClick={() => setVersion(versionNumber)}
                  key={index}
                  className={`CP ${
                    version === versionNumber ? "highlighted" : ""
                  }`}
                >
                  <td>Version {versionNumber}</td>
                </tr>
              ))}
          </tbody>
        </Table>
        {version && (
          <>
            <div className="hstack justify-content-between p-2 position-sticky top-0 z-1">
              <div className="hstack gap-2">
                <Form.Select
                  onChange={(e) => setSchemaId(e.target.value)}
                  style={{ fontSize: 12, width: 200 }}
                  disabled={eventSchema?.length === 0}
                  className="br3"
                >
                  {eventSchema?.length > 0 ? (
                    eventSchema?.map((item, index) => (
                      <option
                        selected={schemaId === item?.schemaId}
                        key={index}
                        value={item?.schemaId}
                      >
                        {item?.schemaName}
                      </option>
                    ))
                  ) : (
                    <option value={""}>No Schema</option>
                  )}
                </Form.Select>
              </div>
            </div>
            <SplitPane
              split="vertical"
              minSize={"100%"}
              style={{ height: "-webkit-fill-available" }}
            >
              {loading && dataLoading ? (
                <div className="hstack justify-content-center h-100">
                  <img src={Loader} alt="Loader" />
                </div>
              ) : (
                <>
                  <Table
                    ref={tableRef}
                    className="m-0 custom-table"
                    hover
                    striped
                  >
                    <thead className="position-sticky top-0 z-1">
                      <tr>
                        <th
                          onMouseDown={(e) => onMouseDown(e, 0)}
                          style={{ width: 45 }}
                          className="text-center"
                        >
                          Sr.
                        </th>
                        {eventColumns?.map((column, index) => (
                          <th onMouseDown={(e) => onMouseDown(e, index + 1)}>
                            {column?.columnLabel}
                          </th>
                        ))}
                        <th
                          onMouseDown={(e) =>
                            onMouseDown(e, (eventColumns || [])?.length + 1)
                          }
                        >
                          Form Name
                        </th>
                        <th
                          style={{ width: 120 }}
                          className="text-center"
                          onMouseDown={(e) =>
                            onMouseDown(e, (eventColumns || [])?.length + 2)
                          }
                        >
                          Assign/Unassign
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {eventRows?.map((row, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}.</td>
                          {eventColumns?.map((column, i) => (
                            <td key={i}>{row?.row[column?.columnName] || ""}</td>
                          ))}
                          <td>
                            {(() => {
                              const eventId = row?.eventId;
                              const timePointId = String(
                                row?.row?.["TIMEPOINTUNIQUEID"] || ""
                              );
                              const matchedItem = eventInitiatedForm?.find(
                                (item) =>
                                  item?.eventId === eventId &&
                                  item?.timePointUniqueId === timePointId
                              );
                              if (matchedItem) {
                                return matchedItem?.formName;
                              } else {
                                return "";
                              }
                            })()}
                          </td>
                          <td className="text-center">
                            {(() => {
                              const eventId = row?.eventId;
                              const timePointId = String(
                                row?.row?.["TIMEPOINTUNIQUEID"] || ""
                              );
                              const matchedItem = eventInitiatedForm?.find(
                                (item) =>
                                  item?.eventId === eventId &&
                                  item?.timePointUniqueId === timePointId
                              );
                              const isUnassignDisabled =
                                !version || matchedItem?.disabled;

                              if (matchedItem) {
                                return (
                                  <button
                                    onClick={() => unassignStudyEventSchemaInitiate( eventId, timePointId)}
                                    disabled={isUnassignDisabled || unassignButtonLoader}
                                    className="removeProfile"
                                    style={{ fontSize: 10 }}
                                  >
                                    {unassignButtonLoader ? (
                                      <div className="hstack gap-2">
                                        <Spinner size="sm"/> Unassiging...
                                      </div>
                                    ) : (
                                      "Unassign Now"
                                    )}
                                  </button>
                                );
                              } else {
                                return (
                                  <button
                                    onClick={() => assignStudyEventSchemaInitiate(eventId, timePointId)}
                                    disabled={!version || assignButtonLoader}
                                    className="updateProfile"
                                    style={{ fontSize: 10 }}
                                  >
                                    {assignButtonLoader ? (
                                      <div className="hstack gap-2">
                                        <Spinner size="sm"/> Assiging...
                                      </div>
                                    ) : (
                                      "Assign Now"
                                    )}
                                  </button>
                                );
                              }
                            })()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </SplitPane>
          </>
        )}
      </SplitPane>
    </>
  );
};

export default EventListForInitiateForm;
